import { containerHabitat as Component } from './container';
export default Component;
